<template>
  <div id="Elegant">

    <Head />
    <div class="elegant">
      <div class="position">
        <img src="../../assets/public/8.png" /> 当前位置:
        <router-link to="/">首页</router-link>>
        <router-link to="/#biaogan">标杆企业</router-link>>员工风采
      </div>
      <div class="Main">
        <h3>员工风采</h3>
        <div class="container">
          <div class="left-box">
            <div class="title">
              <img src="../../assets/Index/s2.png" alt />员工风采
            </div>
            <ul>
              <li :class="{ active: navI == 0 }" @click="getNav(0)">山东能源集团有限公司</li>
              <li :class="{ active: navI == 1 }" @click="getNav(1)">义马煤业集团股份有限公司</li>
            </ul>
          </div>
          <div class="right-box">
            <ul>
              <li v-for="(item, index) in imgs[navI]" :key="index" @click="toDel(1, navI, index)">
                <div>
                  <img :src="item.src" />
                </div>
                <span>{{ item.Title }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Foot />
    </div>
  </div>
</template>
<script>
import Head from "../../components/Head";
import Foot from "../../components/Foot";
export default {
  name: "Elegant",
  data() {
    return {
      navI: 0,
      imgs: [
        [
          {
            src: require("../../assets/staff/10.jpg"),
            Title: "“红星”志愿者烈士墓前寻初心"
          },
          {
            src: require("../../assets/staff/11.jpg"),
            Title: "书香飘逸迎“三八妇女节”"
          },
          {
            src: require("../../assets/staff/12.jpg"),
            Title: "战“疫”有我“青”力而为"
          },
          { src: require("../../assets/staff/13.jpg"), Title: "班前会现场开" },
          {
            src: require("../../assets/staff/14.jpg"),
            Title: "青春战“疫”亮出“志愿红”"
          },
          {
            src: require("../../assets/staff/15.jpg"),
            Title: "严防死守 切断输入性风险源"
          },
          {
            src: require("../../assets/staff/16.jpg"),
            Title: "医务人员无偿献血助力抗疫情"
          },
          {
            src: require("../../assets/staff/17.jpg"),
            Title: "严防输入风险 拧紧疫情防控阀门"
          },
          {
            src: require("../../assets/staff/18.jpg"),
            Title: "热成像测温系统实现就诊人员无接触体温检测"
          }
        ],
        [
          { src: require("../../assets/staff/1.jpg"), Title: "有序推进" },
          { src: require("../../assets/staff/2.jpg"), Title: "抢修设备" },
          { src: require("../../assets/staff/3.jpg"), Title: "快装多运" },
          { src: require("../../assets/staff/4.jpg"), Title: "隐患排查" },
          { src: require("../../assets/staff/5.jpg"), Title: "精准维修" },
          { src: require("../../assets/staff/6.jpg"), Title: "整装待发" },
          { src: require("../../assets/staff/7.jpg"), Title: "志愿服务" },
          { src: require("../../assets/staff/8.jpg"), Title: "检修维护" },
          { src: require("../../assets/staff/9.jpg"), Title: "按章操作" }
        ]
      ]
    };
  },
  components: {
    Head,
    Foot
  },
  methods: {
    getNav(i) {
      this.navI = i;
    },
    toDel(id, i, j) {
      let routeUrl = this.$router.resolve({
        path: "/Notice/NotDel",
        // query: { url:url }
        query: { id: id, xiabiao: i, news: j }
      });
      window.open(routeUrl.href, "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
#Elegant {
  font-size: 0.16rem;
  width: 100%;
  min-width: 1000px;

  .elegant {
    width: 100%;
    margin-top: 0.4rem;
    padding: 0 1.35rem;

    .position {
      display: flex;
      align-items: center;
      padding: 0.1rem;
      background: #f1f1f1;
      color: #2f4f73;

      img {
        width: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    .Main {
      width: 100%;

      h3 {
        text-align: center;
        margin: 0.4rem 0 0.3rem;
        font-size: 0.3rem;
        padding-left: 4rem;
      }

      .container {
        display: flex;
        justify-content: space-between;

        .left-box {
          width: 3.5rem;
          border: 0.01rem solid #ababab;
          margin-bottom: 0.3rem;
          height: 2.8rem;

          .title {
            font-size: 0.2rem;
            width: 100%;
            height: 0.64rem;
            padding: 0.17rem 0.21rem;
            background: #3f6bc2;
            color: #fff;
            line-height: 0.64rem;
            display: flex;
            align-items: center;

            img {
              width: 0.3rem;
              height: 0.3rem;
              margin-right: 0.2rem;
            }
          }

          >ul {
            margin-top: 0.05rem;

            .active {
              background: #84c7fa;
              color: #fff;
            }

            >li {
              border-bottom: 1px solid #bababa;
              padding: 0.17rem;
              cursor: pointer;
            }

            >li:last-child {
              margin-bottom: 1rem;
            }
          }
        }
      }

      .right-box {
        width: 12.41rem;
        // padding: 0.38rem 0.34rem 0 0.28rem;

        ul {
          width: 100%;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          li {
            flex-shrink: 0;
            width: 3.7rem;
            height: 3rem;
            border: 0.01rem solid #efefef;
            padding: 0.2rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            cursor: pointer;
            margin-bottom: 0.3rem;

            > :last-child {
              margin-right: auto;
            }

            >span {
              font-size: 0.16rem;
              color: #555;
            }

            >div {
              width: 100%;
              height: 2.15rem;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                transition: all 1s;

                &:hover {
                  transform: scale(1.2);
                }
              }
            }
          }
        }
      }
    }
  }
}</style>